import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select'

const height = window.innerHeight * .74;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: 'Branch', field: 'BranchId', type: 'numericColumn' },
    { headerName: 'Doctor Id', field: 'ReferrerId', type: 'numericColumn' },
    { headerName: 'Doctor Name', field: 'Doctorname' },
    { headerName: 'Total Bill Amount', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Total Payable', field: 'Payable', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class PayableControlGrid extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }


    fetchPayableSummary = () => {
        this.store.fetchPayableSummary();
        this.store.GetallBranchName();
    }

    countTag = () => {
        if (this.store.isDone) {
            return (
                <>
                    <Tag color="#108ee9">{this.store.rowCount} Rows</Tag>
                    <Tag color="geekblue"> {this.store.totalPayableSum} Total Payable </Tag>
                </>
            )
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }


    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const referrerId = selectedRows[0].ReferrerId;
        const doctorName = selectedRows[0].Doctorname;
        const collectionType = this.store.collectionType;

        const params = { parentKey: "payables", referrerId, doctorName, collectionType };

        this.props.appStore.currentComponent = { label: "Doctor Summary", key: "doctorSummary", params: params };
    }

    render() {

        const payables = this.store.filteredPayables;

        return (
            <>
                <div>
                    <div style={{ display: 'inline-block' }}>
                        <PageHeader style={{ width: '100%', float: "left", paddingTop: 0 }} title={pageSectionTitle(this.props.title)} tags={this.countTag()} />
                    </div>
                    <div style={{ display: 'inline-block', width: '25%', float: 'right' }}>
                        <Select options={this.store.branchList} onChange={(value) => this.store.filterBranch(value.value)} placeholder='Branch' />
                    </div>
                </div>

                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={payables}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchPayableSummary}>
                    </AgGridReact>
                </div>
            </>

        )
    }
}

export default observer(PayableControlGrid)
